<script>
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Default extends Vue {
  render() {
    return (
      <section class="welcome">
        <div>
          <p class="welcome-text">朋友，你是来新建API文档的吗？</p>
          <router-link to="/admin/create" tag="div" exact class="welcome-btn">
            +新建文档
          </router-link>
        </div>
        <div class="welcome-img" />
      </section>
    )
  }
}
</script>

<style lang="postcss">
@import '../../assets/css/_pub.css';
.welcome {
  height: 550px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  &-text {
    font-weight: 600;
  }
  &-img {
    @mixin size 105px, 138px;
    background: url(~@/assets/img/doubt.png) center / cover no-repeat;
  }
  &-btn {
    @mixin size 100px, 30px;
    border: 1px solid var(--border-gray);
    @extend flex-midden;
    margin: 18px auto 0;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/DefaultCreate.vue